import { useTheme } from "@mui/material";
import { useMemo } from "react";
import tinycolor from "tinycolor2";
import { NO_COLOR } from "../../../constants.js";
function useContrastColor(color) {
  const {
    vars: { palette }
  } = useTheme();
  const darkColor = palette.tidalColors.slateBlueGray.A700;
  const lightColor = palette.common.white;
  return useMemo(() => {
    if (color === NO_COLOR) return lightColor;
    return tinycolor(color).isLight() ? darkColor : lightColor;
  }, [lightColor, darkColor, color]);
}
export {
  useContrastColor
};
//# sourceMappingURL=useContrastColor.js.map
